import React from "react";
import QuoteFormHeading from "./QuoteFormHeading";
import { Box } from "@chakra-ui/react";
import FormQuoteActions from "../common-quote/FormQuoteActions";
import FormQuoteSummary from "../common-quote/FormQuoteSummary";
import FormSfActions from "../common-quote/FormSfActions";
import FormCalcSummary from "../common-quote/FormCalcSummary";
import { QuoteFormActions } from "../../lib/types/QuoteFormActions";
import { PdfGenerationActions } from "../../lib/types/PDFGenerationActions";
import { CalculationType } from "../../state/quote-reducer";

export interface QuoteBoxTopProps {
  quoteName: string;
  formActionHandler: (action: QuoteFormActions, values: any) => void;
  formExportHandler: (action: PdfGenerationActions, values: any) => void;
  loadingPdf: boolean;
  isCalculating: boolean | undefined;
  quoteTabs: string[];
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
  calculation: CalculationType;
}

const QuoteBoxTop = (props: QuoteBoxTopProps) => {
  return (
    <>
      <QuoteFormHeading
        quoteName={props.quoteName}
        formActionHandler={props.formActionHandler}
        formExportHandler={props.formExportHandler}
        generatingPdf={props.loadingPdf}
        isCalculating={props.isCalculating}
        quoteTabs={props.quoteTabs}
        setTabIndex={props.setTabIndex}
      />

      <Box display={{ base: "block", lg: "none" }} marginY={4}>
        <FormQuoteActions
          handler={props.formActionHandler}
          exportHandler={props.formExportHandler}
          generatingPdf={props.loadingPdf}
          calculating={props.isCalculating}
        />
      </Box>

      <Box display={{ base: "block", lg: "none" }} marginY={4}>
        <FormQuoteSummary handler={props.formActionHandler} />
      </Box>

      <Box display={{ base: "block", lg: "none" }} marginY={4}>
        <FormSfActions handler={props.formActionHandler} />
      </Box>

      {props.calculation && (
        <Box display={{ base: "block", lg: "none" }} marginY={4}>
          <FormCalcSummary />
        </Box>
      )}
    </>
  );
};

export default QuoteBoxTop;
